<template>
    <FormKit
        class="invoice"
        type="form"
        style="margin-bottom: 100px"
        v-model="invoice"
        @submit="submitHandler"
        :actions="false"
    >
        <div
            class="alert alert-success alert-dismissible fade show"
            role="alert"
            v-if="mailSend"
        >
            Email verstuurd
            <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
                @click="mailSend = false"
            >
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="row bold-labels">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div
                            class="d-flex justify-content-between align-items-center"
                        >
                            <h4 class="card-title mb-0" v-if="invoice.id">
                                Factuur #{{ invoice.id }}
                            </h4>
                            <h4 class="card-title mb-0" v-else>Factuur</h4>

                            <div class="d-flex" v-if="actions">
                                <InvoiceSender
                                    @mailSend="emailSendHandler"
                                    :senders="actions.senders"
                                />

                                <a
                                    type="button"
                                    :href="actions.show_pdf"
                                    target="_blank"
                                    class="ml-3 btn btn-primary"
                                    >Show PDF</a
                                >

                                <a
                                    type="button"
                                    :href="actions.download_pdf"
                                    target="_blank"
                                    class="ml-3 btn btn-primary"
                                    >Download PDF</a
                                >
                                <a
                                    type="button"
                                    :href="actions.download_csv"
                                    target="_blank"
                                    class="ml-3 btn btn btn-primary"
                                >
                                    Download CSV
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                    <FormKit
                                        v-model="invoice.id"
                                        label="Invoice number"
                                        disabled
                                        :classes="{
                                            wrapper: 'mb-0',
                                        }"
                                    />
                                    <small
                                        class="form-text text-muted"
                                        v-if="defaultInvoiceNumber"
                                    >
                                        Invoice number could still be changed by
                                        the system if someone else creates an
                                        invoice with the same number at the same
                                        time.
                                    </small>
                                </div>

                                <FormKit
                                    v-model="invoice.reference_number"
                                    label="Reference number"
                                    validation="length:0,180"
                                />

                                <label class="d-block mb-3">
                                    <span class="d-block mb-2">Total</span>

                                    <input
                                        :value="total"
                                        :key="total"
                                        disabled
                                        class="form-control"
                                    />
                                </label>
                            </div>

                            <div class="col-12 col-md-6">
                                <label class="d-block mb-3">
                                    <span class="d-block mb-2"
                                        >Laatste mutatie</span
                                    >

                                    <input
                                        type="datetime-local"
                                        v-model="invoice.updated_at"
                                        disabled
                                        class="form-control"
                                    />
                                </label>

                                <label class="d-block mb-3">
                                    <span class="d-block mb-2"
                                        >Factuurdatum</span
                                    >

                                    <input
                                        type="datetime-local"
                                        v-model="invoice.invoice_date"
                                        class="form-control"
                                        :disabled="!!invoice.send_date"
                                        :required="!!defaultInvoice"
                                    />
                                </label>

                                <label class="d-block mb-3">
                                    <span class="d-block mb-2"
                                        >Verzonden op</span
                                    >

                                    <input
                                        type="datetime-local"
                                        v-model="invoice.send_date"
                                        class="form-control"
                                        disabled
                                    />
                                </label>
                            </div>

                            <div class="col-12 col-md-6">
                                <FormKit
                                    type="select"
                                    wrapper-class="mr-3 mb-0"
                                    label="Status"
                                    :options="[
                                        'concept',
                                        'planned',
                                        'default',
                                        'reminder',
                                        'overdue',
                                        'paid',
                                    ]"
                                    name="status"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-8 col-xl-9">
                <div class="card">
                    <div class="card-header">
                        <div class="d-flex justify-content-between">
                            <h4 class="card-title mb-0">Factuur regels</h4>
                            <div class="d-flex align-items-center">
                                <p class="m-0 mr-2">
                                    {{ totalBookings }}
                                    {{
                                        totalBookings === 1
                                            ? "boeking"
                                            : "boekingen"
                                    }}
                                </p>
                                <button
                                    type="button"
                                    @click="removeBookings"
                                    class="btn btn-danger"
                                >
                                    Verwijder alle boekingen
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="invoice__items">
                            <p class="mb-0" v-if="!invoice.items.length">
                                <button
                                    type="button"
                                    @click="addItem(0)"
                                    class="btn btn-primary"
                                >
                                    Factuur regel toevoegen
                                </button>
                            </p>
                            <InvoiceItems
                                :items="invoice.items"
                                @update-items="updateItems"
                                @add-item="addItem"
                            />
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        <div class="d-flex justify-content-between">
                            <h4 class="card-title">Optellen/aftrekken</h4>
                            <button
                                type="button"
                                class="btn btn-danger"
                                @click="resetAddSubtract"
                            >
                                <i class="lar la-trash-alt mr-2"></i> Velden
                                leeg maken
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <FormKit
                                    type="select"
                                    label="Optellen/aftrekken"
                                    :options="{
                                        none: 'Optellen/aftrekken',
                                        add: 'Optellen',
                                        subtract: 'Aftrekken',
                                    }"
                                    name="add_subtract"
                                    :validation="addSubtractRules"
                                    v-model="invoice.add_subtract"
                                />
                            </div>
                            <div class="col-12 col-md-4">
                                <FormKit
                                    v-model="invoice.add_subtract_description"
                                    label="Beschrijving"
                                    :validation="addSubtractDescriptionRules"
                                />
                            </div>
                            <div class="col-md-4">
                                <label>Bedrag</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">€</span>
                                    </div>
                                    <input
                                        type="number"
                                        step=".01"
                                        min="0"
                                        max="9999"
                                        class="form-control"
                                        v-model="invoice.add_subtract_amount"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Notities</h4>
                    </div>
                    <div class="card-body">
                        <FormKit type="textarea" v-model="invoice.notes" />
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Logs</h4>
                    </div>
                    <div
                        class="card-body"
                        v-if="!invoice.logs || invoice.logs.length < 1"
                    >
                        <p>No logs found</p>
                    </div>
                    <div v-else class="card-body p-0 table-responsive">
                        <table class="table">
                            <tr>
                                <th>Date</th>
                                <th>Message</th>
                                <th>User</th>
                                <th>IP</th>
                            </tr>
                            <tr v-for="log in invoice.logs">
                                <td>
                                    {{
                                        dayjs(log.created_at).format(
                                            "DD-MM-YYYY HH:mm"
                                        )
                                    }}
                                </td>
                                <td>{{ log.text }}</td>
                                <td>{{ log.username }}</td>
                                <td>{{ log.ip }}</td>
                            </tr>
                        </table>
                    </div>
                </div>

                <div class="card" id="saveActions">
                    <div class="form-group">
                        <input
                            type="hidden"
                            name="_save_action"
                            value="save_and_back"
                        />
                        <button type="submit" class="btn btn-success">
                            Opslaan
                        </button>

                        <a href="/admin/invoices" class="btn btn-default ml-2"
                            ><span class="la la-ban"></span> &nbsp;Annuleren</a
                        >
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-4 col-xl-3">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Klant koppeling</h4>
                    </div>
                    <div class="card-body">
                        <FormKit
                            label="Klant"
                            type="select"
                            name="company_id"
                            :options="companyOptions"
                            v-model="invoice.company_id"
                            validation="required"
                        />

                        <FormKit
                            label="Facturatie gegevens"
                            type="select"
                            :options="invoiceDetailsOptions"
                            v-model="invoice.billing_details_id"
                            name="billing_details_id"
                            validation="required"
                        />
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Factuurgegevens</h4>
                    </div>

                    <div class="card-body">
                        <div v-if="!selectedInvoiceDetails">
                            <p>Kies een klant en de facturatiegegevens.</p>
                        </div>
                        <div v-else>
                            <FormKit
                                label="Contactpersoon"
                                v-model="selectedInvoiceDetails.contact"
                                disabled
                            />

                            <FormKit
                                label="BTW Nummer"
                                v-model="selectedInvoiceDetails.tva_number"
                                disabled
                            />

                            <FormKit
                                label="Stad"
                                v-model="selectedInvoiceDetails.city"
                                disabled
                            />

                            <FormKit
                                label="Adres"
                                v-model="selectedInvoiceDetails.address"
                                disabled
                            />

                            <FormKit
                                label="Postcode"
                                v-model="selectedInvoiceDetails.zipcode"
                                disabled
                            />

                            <FormKit
                                label="Telefoonnummer"
                                v-model="selectedInvoiceDetails.phone_number"
                                disabled
                            />

                            <FormKit
                                label="Publiek nummer"
                                v-model="selectedInvoiceDetails.public_number"
                                disabled
                            />

                            <FormKit
                                label="E-mail"
                                v-model="selectedInvoiceDetails.email"
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </FormKit>
</template>

<script>
import InvoiceItems from "./InvoiceItems.vue";
import InvoiceSender from "./InvoiceSender.vue";
import axios from "axios";
import dayjs from "dayjs";

export default {
    props: ["defaultInvoice", "defaultInvoiceNumber", "action", "actions"],
    components: { InvoiceSender, InvoiceItems },
    data() {
        let invoice = {
            id: this.defaultInvoiceNumber,
            reference_number: "",
            notes: "",
            company_id: null,
            billing_details_id: null,
            invoice_date: null,
            items: [],
            add_subtract: "none",
            add_subtract_description: null,
            add_subtract_amount: null,
            logs: [],
            ...this.defaultInvoice,
        };

        return {
            invoice,
            mailSend: false,
            maisons: [],
            companies: [],
        };
    },
    async mounted() {
        const {
            data: { data: companies },
        } = await axios.post(`/admin/invoices/fetch/company`);

        this.companies = companies;
    },
    methods: {
        dayjs,
        async submitHandler(values, { setErrors }) {
            if (values.add_subtract === "none") {
                values.add_subtract = null;
            }

            const params = new URLSearchParams(document.location.search);

            try {
                if (!this.defaultInvoice) {
                    const {
                        data: { redirect_url, referrer_url },
                    } = await axios.post(this.action, values);

                    if (!referrer_url) {
                        window.location.href = redirect_url;
                    }

                    window.location.href = referrer_url;
                    return;
                }

                await axios.put(this.action + "?" + params, values);

                // By reloading the page after the request we'll show the backpack toast.
                // This prevents us from rebuilding the create/update process for a specific view.
                window.location.reload();
            } catch (e) {
                setErrors(e?.response?.data?.errors);
            }
        },
        addItem(index = null) {
            if (index == null) {
                index = this.invoice.items.length;
            } else {
                index += 1;
            }

            this.invoice.items.splice(index, 0, {
                id: null,
                description: "",
                commission: 0,
                commission_type: "percentage",
                groups: [
                    {
                        group: "",
                        amount: 0,
                        price: 0,
                        commission_type: "fixed",
                        commission: 0,
                    },
                ],
            });
        },
        updateItems(newItems) {
            this.invoice.items = newItems;
        },
        resetAddSubtract() {
            this.invoice.add_subtract = "none";
            this.invoice.add_subtract_description = "";
            this.invoice.add_subtract_amount = "";
        },
        removeBookings() {
            if (confirm("Verwijder alle boekingen van het factuur?")) {
                this.invoice.items = [];
            }
        },
        emailSendHandler({ type, invoice }) {
            this.mailSend = true;
            this.invoice = { ...this.invoice, ...invoice };
        },
    },
    computed: {
        totalBookings() {
            return this.invoice.items?.length ?? 0;
        },
        total() {
            let total = 0;
            if (!this.invoice.items) {
                return total;
            }

            for (let item of this.invoice.items) {
                if (!item.groups) {
                    continue;
                }

                let itemTotal = 0;

                for (let group of item.groups) {
                    let groupTotal = group.amount * group.price;

                    switch (group.commission_type) {
                        case "percentage":
                            itemTotal += (groupTotal / 100) * group.commission;
                            break;
                        case "fixed":
                        default:
                            itemTotal += group.amount * group.commission;
                            break;
                    }
                }

                total += itemTotal;
            }

            return Number(total).toFixed(2);
        },
        billableOptions() {
            return [
                { label: "-", value: "" },
                ...this.maisons.map((item) => ({
                    label: item.name,
                    value: item.id,
                })),
            ];
        },
        invoiceDetails() {
            let billable = this.companies.filter((billable) => {
                return billable.id == this.invoice.company_id;
            })[0];

            if (!billable) {
                return [];
            }

            return billable.billing_details;
        },
        invoiceDetailsOptions() {
            return [
                { label: "-", value: "" },
                ...this.invoiceDetails.map((item) => ({
                    label: item.contact,
                    value: item.id,
                })),
            ];
        },
        selectedInvoiceDetails() {
            let details = this.invoiceDetails.filter(
                (details) => details.id == this.invoice.billing_details_id
            );

            if (!details) {
                return null;
            }

            return details[0];
        },
        companyOptions() {
            return [
                { label: "Select a company", value: "" },
                ...this.companies.map((company) => ({
                    label: company.name,
                    value: company.id,
                })),
            ];
        },
        addSubtractRules() {
            return this.invoice.add_subtract_description ||
                this.invoice.add_subtract_amount
                ? "required"
                : "";
        },
        addSubtractDescriptionRules() {
            return !["none", null].includes(this.invoice.add_subtract)
                ? "required"
                : "";
        },
    },
    watch: {
        "invoice.company_id"() {
            this.invoice.billing_details_id = null;
        },
    },
};
</script>

<style lang="css" scoped>
.invoice__items {
    max-height: 800px;
    overflow-y: auto;
}
</style>
